import React from 'react';
import './HomeSection1.css';

const CONTACT = {
  whatsapp: {
    number: '+19173466654',
    label: 'Message us on WhatsApp',
  },
};

const WHATSAPP_LINK = `https://wa.me/${CONTACT.whatsapp.number.replace(/\D/g, '')}?text=${encodeURIComponent(
  'Hi, I would like to know more about your services.'
)}`;

const CARDS = [
  {
    id: 1,
    category: 'Business Opportunity',
    title: 'Build a Business That Creates Lasting Impact',
    subtitle: 'Create Income, Leadership & Freedom',
    body:
      "Whether you're seeking an additional income stream or looking to build a long-term business, our platform provides the tools, mentorship, and systems needed to help you grow. We believe entrepreneurship should be accessible to everyone willing to learn and take action.",
    bullets: [
      'Proven business model with step-by-step support',
      'Leadership development and personal growth opportunities',
      'Flexible schedule that works around your lifestyle',
      'Build a business while helping families improve their finances',
    ],
    highlight: 'Success grows when purpose meets opportunity.',
    img: '/Images/Business_opp.jpeg',
    imgAlt: 'Business opportunity meeting',
  },
  {
    id: 2,
    category: 'Financial Planning',
    title: 'A Roadmap to Financial Confidence',
    subtitle: 'Plan Today. Prosper Tomorrow.',
    body:
      'Financial success begins with clarity. We help families understand their current financial position, identify opportunities for growth, and build personalized strategies designed to achieve both short-term and long-term goals.',
    bullets: [
      'Personalized wealth-building strategies',
      'Retirement and investment guidance',
      'Protection against unexpected life events',
      "Practical solutions tailored to your family's goals",
    ],
    highlight: 'Financial confidence starts with a clear plan.',
    img: '/Images/fin_plan.png',
    imgAlt: 'Financial planning session',
  },
  {
    id: 3,
    category: 'Health Planning',
    title: 'Protect What Matters Most',
    subtitle: 'Health Security for Every Stage of Life',
    body:
      "Quality healthcare planning provides peace of mind when life's unexpected moments arise. We help individuals and families explore coverage options that balance affordability, flexibility, and long-term protection.",
    bullets: [
      'Coverage options for individuals and families',
      'Guidance through Medicare and supplemental plans',
      'Solutions designed for changing healthcare needs',
      'Support from knowledgeable professionals',
    ],
    highlight: 'A healthy future begins with smart protection today.',
    img: '/Images/Health_plan.jpeg',
    imgAlt: 'Health planning consultation',
  },
  {
    id: 4,
    category: 'Estate Planning',
    title: "Protect Your Family's Legacy",
    subtitle: 'Planning Today for Generations Tomorrow',
    body:
      "Estate planning is about more than documents—it's about ensuring your wishes are honored and your loved ones are protected. We simplify the process and help families create plans that provide security and peace of mind.",
    bullets: [
      'Simple online planning process',
      'Affordable solutions for every family',
      'Secure document storage and updates',
      'Tools designed to protect assets and loved ones',
    ],
    highlight: 'Leave a legacy of security, not uncertainty.',
    img: '/Images/estate.jpeg',
    imgAlt: 'Estate planning documents',
  },
];

// ── SINGLE CARD COMPONENT ─────────────────────────────────────
function HeroCard({ card, reverse }) {
  return (
    <>
      <div className={`hero-card ${reverse ? 'reverse' : ''}`}>
        <div className="hero-card-image-col">
          <div className="hero-card-image-wrapper">
            <img
              src={card.img}
              alt={card.imgAlt}
              className="hero-card-img"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.style.background = '#141313';
                e.target.parentNode.style.minHeight = '300px';
              }}
            />
          </div>
        </div>

        <div className="hero-card-text-col">
          <span className="hero-card-category">{card.category}</span>

          <h3 className="hero-card-title">{card.title}</h3>

          <p className="hero-card-subtitle">{card.subtitle}</p>

          {card.body && <p className="hero-card-body">{card.body}</p>}

          {card.bullets && card.bullets.length > 0 && (
            <ul className="hero-card-list">
              {card.bullets.map((bullet, i) => (
                <li key={bullet.slice(0, 30) + i}>{bullet}</li>
              ))}
            </ul>
          )}

          {card.highlight && (
            <div className="hero-card-highlight">{card.highlight}</div>
          )}

          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-card-link"
            aria-label={CONTACT.whatsapp.label}
          >
            WhatsApp
            <span className="hero-card-link-arrow">→</span>
          </a>
        </div>
      </div>

      {card.id < CARDS.length && <div className="hero-card-divider" />}
    </>
  );
}

// ── MAIN SECTION COMPONENT ────────────────────────────────────
function HomeSection1() {
  return (
    <section className="hero-section-wrapper">
      <div className="hero-section-header">
        <h2 className="hero-section-title">
          <span>Build the Life and Business You Deserve.</span>
        </h2>

        <p className="hero-section-desc">
          From financial planning to estate protection, we cover every
          pillar of your wealth-building journey. Powered by people,
          for people.
        </p>
      </div>

      <div className="hero-cards-container">
        {CARDS.map((card, index) => (
          <HeroCard
            key={card.id}
            card={card}
            reverse={index % 2 !== 0}
          />
        ))}
      </div>
    </section>
  );
}

export default HomeSection1;